<template>
  <div class="mapReminderVideo">
    <div class="reminderNameTitle" v-if="itemInfo">
      <div class="reminderName">{{ itemInfo.name }}</div>
      <i
        class="iconfont icon-guanbi2"
        style="color: red"
        @click="closeReminder"
      ></i>
    </div>
    <div class="reminderDetail" v-if="itemInfo">
      <img :src="itemInfo.info && itemInfo.info.partUrl" alt="" />
    </div>
    <div class="operation">
      <el-button size="small" @click="playVideo">回放</el-button>
    </div>
    <h-video-dialog
      v-if="showVideoDialog"
      v-model:visible="showVideoDialog"
      :videoData="videoDialogData"
      title="视频回放"
    ></h-video-dialog>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";

export default defineComponent({
  name: "mapReminderVideo",
  components: {},
  props: {
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, context) {
    const data = reactive({
      videoDialogData: {},
      showVideoDialog: false,
    });
    const refData = toRefs(data);
    const closeReminder = () => {
      context.emit("close");
    };
    const playVideo = () => {
      data.videoDialogData = {
        deviceId: props.itemInfo.info.sourceId,
        passTime: props.itemInfo.info.passTime,
      };
      data.showVideoDialog = true;
    };
    return {
      ...refData,
      closeReminder,
      playVideo,
    };
  },
});
</script>
<style lang="scss" scoped>
.mapReminderVideo {
  width: 230px;
  height: 262px;
  background: rgba(8, 13, 38, 0.8);
  color: #14d1b3;
  background-size: 100% 100%;
  padding: 10px;
  font-size: 14px;
  .reminderNameTitle {
    width: 100%;
    height: 15px;
    @include flex-row-sb-c;
    margin-bottom: 15px;
    i {
      cursor: pointer;
      // pointer-events: none;
    }
  }

  .reminderDetail {
    width: 100%;
    height: calc(100% - 75px);
    @include flex-row-c-c;
    img {
      width: 80%;
      height: 100%;
    }
  }
  .reminderDetail ::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 10px solid;
    border-color: transparent;
    border-top-color: rgba(8, 13, 38, 0.8);
    top: 100%;
    left: 50%;
    margin-left: -10px;
  }
  .operation {
    width: 100%;
    height: 30px;
    margin-top: 15px;
    @include flex-row-c-c;
  }
}
</style>
